// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__ZmeNa","errors":"Errors_errors__2YlpS"};